import type { PluginContext } from "./types";

export type ConsentUiChoice = "denied" | "analytics" | "personalization";

/** Records an explicit UI answer separately from the effective collection policy. */
export function recordConsentResponse(
  ctx: Pick<
    PluginContext,
    "config" | "siteKey" | "storage" | "canTrackCategory" | "track"
  >,
  choice: unknown,
  source: "prospix_ui" | "marketing_banner_v1",
) {
  if (
    choice !== "denied" &&
    choice !== "analytics" &&
    choice !== "personalization"
  )
    return false;
  const mode = ctx.config.privacy.consentEnforcement ?? "required";
  try {
    ctx.storage.set(
      `prospix_ui_response_v1_${ctx.siteKey || "default"}`,
      JSON.stringify({
        version: 1,
        choice,
        mode,
        updatedAt: Date.now(),
      }),
    );
  } catch {
    /* The click still works if storage is unavailable. */
  }
  if (ctx.canTrackCategory("consent_analytics")) {
    ctx.track("consent_banner_interaction", {
      response_version: 1,
      choice,
      consent_mode: mode,
      cmp_source: source,
      action: choice === "denied" ? "reject" : "accept",
    });
  }
  return true;
}
